import { useEffect } from 'react'

export function useIntersectionObserver({
  observerCallback,
  observerOptions,
  thresholdElement,
}) {
  useEffect(() => {
    const currentElement = thresholdElement
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [observerCallback, thresholdElement])
}
